import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Alert, AlertDescription } from '../ui/alert';
import { AlertTriangle, ArrowRight } from 'lucide-react';
import { pct, num } from './format';

const Step = ({ label, value }) => (
  <div className="min-w-0">
    <p className="text-xs text-muted-foreground uppercase tracking-wider">{label}</p>
    <p className="font-mono text-lg font-bold">{num(value)}</p>
  </div>
);

export const CheckoutStep = ({ data, isPortal }) => {
  if (!data) return <div className="h-28 rounded-lg bg-muted animate-pulse" />;
  if (!data.available) return isPortal ? null : <p className="text-sm text-muted-foreground" data-testid="checkout-step-unavailable">{data.reason}</p>;
  return (
    <div className="space-y-3" data-testid="checkout-step">
      {!isPortal && data.tracking_missing && (
        <Alert variant="destructive" data-testid="checkout-tracking-alert">
          <AlertTriangle className="h-4 w-4" />
          <AlertDescription>O evento add_shipping_info não está sendo registrado nesta loja. A etapa de frete do checkout não está sendo medida.</AlertDescription>
        </Alert>
      )}
      <Card>
        <CardContent className="p-5 flex flex-wrap items-center gap-6">
          <Step label="Início do checkout" value={data.begin_checkout} />
          <div className="text-center"><ArrowRight className="h-4 w-4 mx-auto text-muted-foreground" /><p className="text-sm font-mono font-semibold" data-testid="checkout-rate-shipping">{pct(data.rate_to_shipping)}</p></div>
          <Step label="Informou o frete" value={data.add_shipping_info} />
          <div className="text-center"><ArrowRight className="h-4 w-4 mx-auto text-muted-foreground" /><p className="text-sm font-mono font-semibold" data-testid="checkout-rate-payment">{pct(data.rate_to_payment)}</p></div>
          <Step label="Pagamento" value={data.add_payment_info} />
        </CardContent>
      </Card>
    </div>
  );
};
